module.exports = __webpack_public_path__ + "static/img/dragontiger2_en.c0eed72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/dragontiger2_en.png
// module id = gOas
// module chunks = 1